import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import userService from "./services/UserService";
import angebotService from "./services/AngebotService";
import settingService from "./services/SettingsService";
import router from "./router";
import Settings from "./components/Settings.json";




Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: localStorage.getItem("user") || "",
    token: localStorage.getItem("token") || "",
    merkliste: localStorage.getItem("merkliste") || {},
    places: localStorage.getItem("places") || [],
    status: {},
    lang: "DE",
    error: "",

    settings: Settings,
  },
  mutations: {
    loginRequest(state, user) {
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;

    },
    acceptPolicy(state) {
      let user;
      if(typeof(state.user) === "string" || state.user instanceof String){
        user =  JSON.parse(state.user);
      } else {
        user = state.user;
      }
      user.confirmedPolicy = 1;
      localStorage.setItem("user", JSON.stringify(user));
      state.user = user;
    },
    loginFailure(state, errorText) {
      state.status = { loggedIn: false };
      state.user = null;
      state.merkliste = {};
    },
    logout(state) {
      state.status = {};
      state.user = null;
      state.merkliste = {};
    },
    registerRequest(state, user) {
      state.status = { registering: true };
    },
    registerSuccess(state, user) {
      state.status = {loggedIn: true};
      state.user = user;
    },
    registerFailure(state, error) {
      state.status = {};
      state.user = null;
    },
    updateUser(state, user){
      state.user = user;
    },
    error(state, errorText){
      state.error = errorText;
    },
    updateMerkliste(state, merkliste){
      state.merkliste = merkliste;
    },
    updateOrte(state, list){
      state.places = list;
    },
    updateLanguage: function(state, newLang) { state.lang = newLang; }
  },

  actions: {
    async login({ commit, dispatch }, { username, password }) {
      commit("loginRequest", { username });
      userService
        .login(username, password)
        .then(function(response) {
          if(response.data == "Keinen User mit den eingegeben Daten gefunden")
          {
            commit("error", response.data)
            commit('loginFailure');
          } else {
            let userObj = response.data[0];

            //Account nicht aktiv
            if(userObj.expirationdate != null){
              if(userObj.expirationdate == "0000-00-00 00:00:00"){
                if (userObj) {
                  let id;
                  let _this = this;
                  if(userObj.type == 0){
                    id = userObj.persistence_object_identifier;
                  } else {
                    id = userObj.account;
                  }

                  if(userObj.type == 1){
                    if(userObj.confirmedPolicy == null){
                      userObj.confirmedPolicy = 0;
                    }
                    angebotService.getMerkliste(id).then(function (res) {
                      localStorage.setItem("merkliste", JSON.stringify(res.data));
                      _this.dispatch("updateMerkliste",id);
                    })
                  }

                  localStorage.setItem("token", userObj.type);
                  localStorage.setItem("user", JSON.stringify(userObj));

                  axios.defaults.headers.common["Authorization"] = userObj.type;

                  commit('loginSuccess', userObj);
                  if(userObj.type == 1) {
                    dispatch('updateMerkliste', id);
                  }
                  dispatch('updatePlaces');
                  router.push({ name: 'home'})
                  commit("error", "")

                }
              }
              else {
                console.log("Error")
                commit("error", "Benutzer ist noch nicht aktiviert worden. Bitte beachten Sie die Informationen in Ihrem Postfach.")
                commit('loginFailure', );
                console.log(state.error)
              }


            }
            else {
              if (userObj) {
                let id;
                if(userObj.type == 0){
                  id = userObj.persistence_object_identifier;
                } else {
                  id = userObj.account;
                }
                angebotService.getMerkliste(id).then(function (res) {
                  localStorage.setItem("merkliste", JSON.stringify(res.data));
                  dispatch("updateMerkliste",id);
                })
                localStorage.setItem("token", userObj.type);
                localStorage.setItem("user", JSON.stringify(userObj));

                axios.defaults.headers.common["Authorization"] = userObj.type;

                commit('loginSuccess', userObj);
                console.log("Login");
                dispatch('updateMerkliste', id);
                dispatch('updatePlaces');


              }
            }
          }
        })
        .catch(function(error) {
          commit('loginFailure');
        });
    },
    logout({ commit }) {
      userService.logout();
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("merkliste");
      localStorage.removeItem("angebotToEdit");
      localStorage.removeItem("AngebotCreation");
      localStorage.removeItem("AngebotCreationStep");
      localStorage.removeItem("places");
      commit("logout");
    },
    register({ commit,dispatch }, user) {
      commit("registerRequest", user);
    
      userService.register(user)
          .then(function (response) {
            //let user = response.data[0];
            commit("registerSuccess", user);
            dispatch('login', {username: user.email, password: user.password});
          })
          .catch(function (error) {
            commit("registerFailure", error);
            alert("Es gab einen Fehler beim registieren.")
          })

    },
    updateUser({ commit },user){
      localStorage.removeItem("user");
      localStorage.setItem("user", JSON.stringify(user));
      commit("updateUser", user);
    },
    acceptPolicy({commit}){
      commit('acceptPolicy');
    },
    updateMerkliste({commit}, id){
      angebotService.getMerkliste(id).then(function (res) {
        localStorage.setItem("merkliste", JSON.stringify(res.data));
        commit('updateMerkliste', JSON.stringify(res.data));
      })
    },
    updatePlaces({commit}){
      let list = [];
      list.push({ text: 'Freiburger Stadtteile', value: null, disabled: true, optgroup: true });

      settingService.getSettings(1).then(function (res) {
        for(let i = 0; i < res.data.length; i++){
          let item = {text: res.data[i].SettingValue.toString(), value:res.data[i].SettingId, index: i};
          list.push(item)
        }

        settingService.getSettings(2).then(function (res) {
          list.push({ text: 'Orte in Umgebung', value: null, disabled: true, optgroup: true });
          for(let i = 0; i < res.data.length; i++){
            let item = {text: res.data[i].SettingValue.toString(), value:res.data[i].SettingId, index: i};
            list.push(item)
          }
          commit('updateOrte', list);
          localStorage.setItem("places", JSON.stringify(list));
          router.push({ name: 'home'})
        })
      })
    }
  },
  getters: {
    loggedIn (state) {
      return !!state.user
    },
    lang (state) {
      return state.lang
    },
    status(state){
      return state.status
    },
    error(state){
      return state.error
    },
    merkliste(state){
      return state.merkliste
    },
    userObject(state){
      if(state.user){
        if(typeof(state.user) === "string" || state.user instanceof String){
          let user =  JSON.parse(state.user);
          return user;
        } else {
          return state.user;
        }
      } else {
        return state;
      }

    },
    userStatus (state) {
      if(!!state.user){
        if(typeof(state.user) === "string" || state.user instanceof String){
          let user =  JSON.parse(state.user);
          return user.type;
        } else {
          return state.user.type;
        }
      } else {
        return 5
      }

    },
    places(state){
      if(typeof(state.places) === "string" || state.places instanceof String){
        let places =  JSON.parse(state.places);
        return places;
      } else {
        return state.places;
      }
    }
  },
  methods: {
    loginError () {
      return state.status;
    }
  }
});
